import { createRoot } from 'react-dom/client'

import './local'
import './i18n'
import './index.css'
import './portal.css'

import App from './App'
import AnalyticsScript from './Util/AnalyticsScript'

createRoot(document.getElementById('root')!).render(
  <>
   {window.location.origin.includes("localhost") &&  <AnalyticsScript />}
    <App />
  </>,
)
